import { io } from 'socket.io-client';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SOCKET_URL = API_BASE_URL.replace(/\/api\/?$/, '');

let socket = null;

export const connectRealtime = () => {
  if (socket) return socket;
  const token = localStorage.getItem('token');
  socket = io(SOCKET_URL, {
    transports: ['websocket'],
    auth: token ? { token } : undefined,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 800,
  });
  return socket;
};

export const joinOrderRoom = (orderId) => {
  const client = connectRealtime();
  client.emit('join_order', { orderId });
};

export const leaveOrderRoom = (orderId) => {
  if (!socket) return;
  socket.emit('leave_order', { orderId });
};

export const onRealtimeEvent = (event, handler) => {
  const client = connectRealtime();
  client.on(event, handler);
  return () => client.off(event, handler);
};

export const disconnectRealtime = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
